<lib-anc-dialog
    [title]="'Session about to expire'"
    [showClose]="false"
>
    <span
        dialogHeaderLeading
        class="icon icon-alert icon-alert-triangle idle-warning-modal__icon"
        aria-hidden="true"
    ></span>

    <div class="idle-warning-modal__body" aria-live="polite">
        <div class="idle-warning-modal__countdown">{{ remainingSeconds }}</div>
        <p class="idle-warning-modal__message" translate>
            You will be logged out in seconds due to inactivity.
        </p>
    </div>

    <ng-container dialogFooter>
        <button
            type="button"
            libAncButton
            variant="secondary"
            size="medium"
            (click)="logoutNow()"
            translate
        >
            Log out now
        </button>
        <button
            type="button"
            libAncButton
            variant="primary"
            size="medium"
            (click)="stayLoggedIn()"
            translate
        >
            Stay logged in
        </button>
    </ng-container>
</lib-anc-dialog>
